module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-infinity-atrium.76a8210e.jpg";